module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/favicon-30dd42daf167ebf4ed79d9edd369a0fb.ico";